import { NestedTreeNode } from '@thehubz/client/core';

export interface AssetNestedTreeNode extends NestedTreeNode {
  assetId: string;
  version: number;
}
